import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { Form } from 'antd';
import React from 'react';
import { SonarText } from '@ui/text';

import { ComplianceCategoryFormSelector, DataSensitivityFormSelector } from '@ui/tags';

export const ConfigurableFieldAccess: React.FC = () =>
	<>
		<SonarText className='subheading'>{ COPY_SPECIFIC.DATA_SENSITIVITY }</SonarText>
		<Form.Item name={ [ 'monitorConfig', 'dataSensitivityLevels' ] }>
			<DataSensitivityFormSelector
				mode='multiple'
				placeholder={ COPY_SPECIFIC.ALL } />
		</Form.Item>
		<SonarText className='subheading'>{ COPY_SPECIFIC.COMPLIANCE_CATEGORY }</SonarText>
		<Form.Item name={ [ 'monitorConfig', 'complianceCategories' ] }>
			<ComplianceCategoryFormSelector
				includeAny
				mode='multiple'
				placeholder={ COPY_SPECIFIC.ALL } />
		</Form.Item>
	</>;
